exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.switch-btn[data-v-ddf644b2] {\r\n    margin: auto;\r\n    padding: 0 0.5rem;\r\n    height: 24px;\r\n    font-size: small;\r\n    line-height: 24px;\r\n    color: #fff;\r\n    background: #3575c8 !important;\r\n    border-radius: 5px;\n}\r\n", ""]);

